import axios from "axios"
import moment from 'moment'
import { I18n } from 'react-redux-i18n'

import {getHeaders} from "../helpers/urlHelper"

import {history} from "../helpers/history"

import {defaultConfig} from "../config"

//User login action
export function otherUserLogin(user, password) {
  return function(dispatch) {
    dispatch({type: "OTHER_USER_FETCH_LOGIN"})

    axios.post(defaultConfig.url + "/other-user/login", {
        "user":user,
        "password":password
      },
      {
        headers: getHeaders()
      })
      .then((response) => {
        const expires_at = moment().add(response.data.expires_in, 'seconds')

        //Set local storage token
        localStorage.setItem('other_user_token', response.data.token)
        localStorage.setItem('other_user_expires_at', expires_at.unix())
        localStorage.setItem('other_user', JSON.stringify(response.data.otherUser))

        //Set logged in to true
        dispatch({type: "OTHER_USER_FETCH_LOGIN_FULFILLED", payload: {
          user: response.data.otherUser,
          expires_at: expires_at
        }})

        // Show success snackbar
        dispatch({type: "SHOW_SNACKBAR", payload: {
          variant: 'success',
          message: I18n.t('global.logged_in'),
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          duration: 1600
        }})

        if(response.data.otherUser.preference === "w"){
          history.push(`/week/${moment().format('YYYYMMDD')}`)
        }else{
          history.push(`/month/${moment().format('YYYYMMDD')}`)
        }
      })
      .catch((err) => {
        dispatch({type: "OTHER_USER_FETCH_LOGIN_REJECTED", payload: err})

        if(err.response && err.response.status === 401) {

          // Show error snackbar
          dispatch({type: "SHOW_SNACKBAR", payload: {
            variant: 'error',
            message: err.response.data.message,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 3000
          }})

          // Log user out
          // Delete otheruser localStorage login token
          localStorage.removeItem('other_user_token')
          localStorage.removeItem('other_user_expires_at')
          localStorage.removeItem('other_user')

          dispatch({type: "OTHER_USER_LOGOUT"})

          // Send user to Home page
          //history.push('/')
        }else{
          // Show error snackbar
          dispatch({type: "SHOW_SNACKBAR", payload: {
            variant: 'error',
            message: I18n.t('global.server_error'),
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 5000
          }})

        }
      })
  }
}

//Check if other user token is still valid
export function checkOtherUserLoggedIn(){
  return function(dispatch) {
    if(localStorage.getItem('other_user_token')){

      const expires_at_old = moment.unix(localStorage.getItem('other_user_expires_at'))

      // Check if token expired on client side
      if(moment().diff(expires_at_old) > 0) {
        // Show error snackbar
        dispatch({type: "SHOW_SNACKBAR", payload: {
          variant: 'error',
          message: I18n.t('global.other_user_session_expired'),
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          duration: 5000
        }})

        //Delete localStorage login token
        localStorage.removeItem('other_user_token')
        localStorage.removeItem('other_user_expires_at')
        localStorage.removeItem('other_user')

        //Set logged in to false
        dispatch({type: "OTHER_USER_LOGOUT"})

        // Send user to login page
        history.push('/')

        return
      }else{
        //Set logged in to true
        dispatch({type: "OTHER_USER_LOGGED_IN", payload: {
          user: JSON.parse(localStorage.getItem('other_user')),
          expires_at: moment.unix(localStorage.getItem('other_user_expires_at'))
        }})
      }
    }
  }
}

export function otherUserLogout(){
  return function(dispatch) {
    //Delete localStorage login token
    localStorage.removeItem('other_user_token')
    localStorage.removeItem('other_user_expires_at')
    localStorage.removeItem('other_user')

    //Set logged in to false
    dispatch({type: "OTHER_USER_LOGOUT"})

    // Send user to login page
    history.push('/')
  }
}



// WEBPACK FOOTER //
// ./src/js/actions/otherUserActions.js